export default __webpack_public_path__ + "static/media/plumber-3.f0489919.png";